import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaD_Van_Center: React.FC<AreaSVGProps> = ({
  fill = '#148B4D',
  stroke = '#148B4D',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="87"
      height="23"
      viewBox="0 0 87 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_d_van_center"
          x="0"
          y="0"
          width="87"
          height="23"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_d_van_center)">
        <path
          d="M75.2344 1.10059C76.9572 2.70314 79.001 4.35039 80.7363 5.85742C82.2824 7.2001 83.8529 8.6468 85.3789 10.2822C83.2537 11.3246 81.0143 12.1722 77.5439 13.3906L74.7734 14.3564C57.1247 18.2412 40.0016 21.7722 3.25684 21.9902L1 21.9961V10.5557C21.6013 10.3371 39.6695 8.05196 53.7363 5.59277C61.1189 4.30213 67.1514 3.01025 71.3486 2.03809C72.9041 1.67781 74.207 1.35738 75.2344 1.10059Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
